// @flow
import type { AxiosError } from '@lib/types';
import type { Action } from './types';

import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_CLEAR_ERROR
} from './constants';

export const requestForgotPassword = (email: string): Action => ({
  type: FORGOT_PASSWORD_REQUEST,
  email
});

export const forgotPasswordSuccess = (): Action => ({
  type: FORGOT_PASSWORD_SUCCESS
});

export const forgotPasswordFailure = (error: AxiosError): Action => ({
  type: FORGOT_PASSWORD_FAILURE,
  error
});

export const clearForgotPasswordError = (): Action => ({
  type: FORGOT_PASSWORD_CLEAR_ERROR
});
